import { render, staticRenderFns } from "./ReportProgress.vue?vue&type=template&id=64b689c0&"
import script from "./ReportProgress.vue?vue&type=script&lang=js&"
export * from "./ReportProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports